import { getData } from '../../core/preference';
import axios from 'axios';
// import { tokenStorage } from '@/shared/lib/token';
export const http = axios.create({
  baseURL: 'https://proj2-api.elm.tj/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(async (config) => {
  const token = await getData('token');
  console.log("DDDD",token)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Unauthorized — redirect to login');
    }
    return Promise.reject(error);
  }
);